import { render, staticRenderFns } from "./BackUpAppRecommend.vue?vue&type=template&id=5f387aa2&"
import script from "./BackUpAppRecommend.vue?vue&type=script&lang=ts&"
export * from "./BackUpAppRecommend.vue?vue&type=script&lang=ts&"
import style0 from "./back_up_app_recommend.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports